import React from "react";

export default function ExecutiveSummaryCard(
{
    title = "AI Executive Summary",

    summary
})
{
    const container =
    {
        width: "450px",

        height: "85px",

        marginLeft: "14px",

        padding: "12px 18px",

        boxSizing: "border-box",

        background: "white",

        border: "1px solid #E8EDF3",

        borderRadius: "10px",

        display: "flex",

        flexDirection: "column",

        justifyContent: "center",

        boxShadow:
            "0 8px 24px rgba(31,59,103,.10)"
    };

    const titleStyle =
    {
        fontSize: "12px",

        fontWeight: 700,

        color: "#1F3B67",

        textTransform: "uppercase",

        letterSpacing: "1.2px",

        marginBottom: "5px"
    };

    const summaryStyle =
    {
        fontSize: "12px",

        color: "#596474",

        lineHeight: "16px",

        whiteSpace: "nowrap",

        overflow: "hidden",

        textOverflow: "ellipsis"
    };

    return (

        <div style={container}>

            <div style={titleStyle}>
                {title}
            </div>

            <div style={summaryStyle}>
                {summary}
            </div>

        </div>

    );
}